{
  "eyebrow": "Tarif bestätigen",
  "title": "Prüfen & konfigurieren.",
  "sub": "Abrechnungszyklus oder Tarif können Sie jederzeit über Ihr Admin-Dashboard ändern.",
  "yourPlan": "Ihr Tarif",
  "changePlan": "Tarif ändern",
  "billing": "Abrechnungszyklus",
  "billingMonthLabel": "Monatlich zahlen",
  "billingMonthDesc": "Flexibel. Jederzeit kündbar.",
  "billingYearLabel": "Jährlich zahlen",
  "billingYearDesc": "15% Rabatt. Einmal jährlich abgerechnet.",
  "addons": "Zusatzmodule",
  "addon": {
    "ssec": "Sozialversicherung (Check-in/out@work)",
    "ssecDesc": "Nur Belgien — automatische Dimona-Meldung.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "Live-GPS für Firmenfahrzeuge. +4,80 €/Fahrzeug/Monat.",
    "vehicles": "Fahrzeuge"
  },
  "users": {
    "title": "Wie viele Nutzer benötigen Sie?",
    "help": "Jede Person, die Done-it nutzt, zählt als ein Nutzer – einschließlich Administratoren und Mitarbeitenden.",
    "active": "Benutzer"
  },
  "estimate": "Geschätzte monatliche Kosten",
  "estimateNote": "Zzgl. MwSt. Sie zahlen für die hier eingestellte Anzahl an Benutzern und können sie später ändern.",
  "estimateUnavailable": "Preiskatalog nicht verfügbar. Erneut versuchen, um die aktuellen Preise zu laden."
}
